import { apiClientWithRefreshToken } from "@/api/apiClient";

export default async function DeleteApproveSupplier(id: string): Promise<void> {
    await apiClientWithRefreshToken({
        url: `/vendors/${id}`,
        method: "DELETE",
    });
}
